// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loading_overlay__2fZMK"};